<template>
  <div class="pull-right" :class="displayClasses">
    <!-- START User Info-->
    <div class="visible-lg visible-md flex-align">

      <notifications v-if="!mobile && renderNotifications"></notifications>

      <div class="dropdown">
        <div class="m-l-20 fs-16 font-heading profile-dropdown-toggle profile__button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <div v-if="decodedEMail">
            <span class="semi-bold">{{ decodedEMail.localPart }}</span><span class="text-master">@{{ decodedEMail.domain }}</span>
            <i class="fa fa-chevron-down"></i>
          </div>
        </div>
        <!-- <button class="profile-dropdown-toggle"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
          <span class="thumbnail-wrapper d32 circular inline">
            <img src="~assets/img/profiles/avatar.jpg"
                 alt=""
                 data-src="~assets/img/profiles/avatar.jpg"
                 data-src-retina="~assets/img/profiles/avatar_small2x.jpg"
                 width="32"
                 height="32">
          </span>
        </button> -->
        <ul class="dropdown-menu profile-dropdown profile-dropdown--placement" role="menu">
          <li>
            <a href="#">
              <i class="pg-settings_small"></i> Réglages</a>
          </li>
          <li>
            <a href="#">
              <i class="pg-outdent"></i> Retour Utilsateur</a>
          </li>
          <li>
            <a href="#">
              <i class="pg-signals"></i> Aide</a>
          </li>
          <li class="bg-master-lighter">
            <a href="#"
               class="clearfix">
              <span class="pull-left">
                <a @click.prevent="logout">Déconnexion</a>
              </span>
              <span class="pull-right">
                <i class="pg-power"></i>
              </span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <!-- END User Info-->
  </div>
</template>

<style lang="scss" scoped>
  .flex-align {
    display: flex !important;
    height: 60px;
    align-items: center;
  }
  .profile-dropdown--placement {
    transform: translate(-55px, 8px);
  }
  .profile__button {
    border: 2px solid #777;
    border-radius: 20px;
    padding: 4px 10px 6px 12px;
    .fa {
      font-size: 12px;
      transform: translateY(-1px);
    }
  }
</style>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex'
  import notifications from './Notifications'

  export default {
    data () {
      return {
        renderNotifications: false
      }
    },
    mounted () {
      this.$store.watch((notifications) => { this.renderNotifications = true })
    },
    components: {
      notifications
    },
    props: {
      logout: {},
      email: {},
      mobile: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      decodedEMail () {
        const splited = (this.email) ? this.email.split('@') : null

        return splited && {
          localPart: splited[0],
          domain: splited[1]
        }
      },

      displayClasses() {
        return this.mobile == true ? 'visible-sm visible-xs' : 'hidden-sm hidden-xs'
      }
    },
  }
</script>



// WEBPACK FOOTER //
// client/components/Header/UserInfo.vue